import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Globals } from 'src/app/globals';
import { AdmService } from '../../../service/adm.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {

  showLoader: boolean = false;
  questions: any;
  currentQuestionName: any;
  currentQuestionId = 0;
  ignoreColumns = [9, 8];

  constructor(private toastrService: ToastrService, public admService: AdmService, public globals: Globals, private router: Router, public translate: TranslateService) { }

  ngOnInit(): void {
    this.getAllQuestions();
  }

  getAllQuestions() {
    this.showLoader = true;
    this.admService.getQuestions()
      .subscribe(
        data => {
          this.questions = data;
          this.updateTable();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_STATUS'));
          this.showLoader = false
        },
        () => this.showLoader = false
      );
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      var table = $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // responsive: {
        //   details: {
        //     type: 'column',
        //     target: 'tr'
        //   }
        // },
        // orderCellsTop: true,
        // fixedHeader: true,
        // scrollX: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   // {targets: "hiddenCols", visible: false,
        //   // }
        //   {
        //     "orderable": false, "targets": this.ignoreColumns, render: function (data: any, type: any, row: any) {
        //       if (type = 'myExport') {
        //         return data.split(' ').reverse().join(' ');
        //       }
        //       return data;
        //     }
        //   }
        // ],

        "columnDefs": [
          // {targets: "hiddenCols", visible: false,
          // }
          {
            "orderable": false, "targets": this.ignoreColumns
          }
        ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        searching: false,
        // search: {
        //   searchPlaceholder: "Search",
        // },
        paging: true,
        // language: {
        //   search: "",
        //   searchPlaceholder: "Search",
        // },
        // buttons: [
        //   'excel', 'pdf'
        // ]
        buttons: [{
          extend: 'csvHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'CSV'
        },
        {
          extend: 'pdfHtml5',
          text: '<span style="font-size: 3em; color: #e04006;"><i class="fas fa-file-pdf fa-sm"></i></span>',
          titleAttr: 'PDF'
        }]
        // buttons: [
        //   {
        //     extend: "pdfHtml5",
        //     orientation: "landscape",
        //     pageSize: "A4",
        //     exportOptions: {
        //       "orthogonal": "myExport",
        //       "columns": [0, 1, 2, 3, 4, 5, 6, 7]
        //     },
        //     customize: function (doc: any) {
        //       // doc.defaultStyle = {
        //       //   font: "Cairo"
        //       // };
        //       doc.styles.tableBodyEven.alignment = "center";
        //       doc.styles.tableBodyOdd.alignment = "center";
        //     }
        //   },
        //   {
        //     extend: "excelHtml5",
        //     exportOptions: {
        //       "columns": ":visible"
        //     }
        //   }
        // ]
      });

      // Setup - add a text input to each footer cell
      // $('#datatable thead tr').clone(true).appendTo('#datatable thead');
      // $('#datatable thead tr:eq(1) th').each(function (i: any) {
      //   let obj = $('#datatable thead tr:eq(1) th')[i];
      //   let ignoreColumns = [6, 7];
      //   if (!ignoreColumns.includes(i)) {
      //     var title = $(obj).text();
      //     let textId = "datatable_header_" + i + "_input_text";
      //     $(obj).html('<input type="text" placeholder="Search ' + title + '" id="' + textId + '"/>');

      //     $("#" + textId).on('keyup change', function (e: any) {
      //       if (table.column(i).search() !== $(e.target).val()) {
      //         console.log($(e.target));
      //         console.log($(e.target).val());
      //         table
      //           .column(i)
      //           .search($(e.target).val()).draw();
      //       }
      //     });
      //   }
      // });
    }, 2);
  }

  editQuestion(id: any) {
    this.router.navigate(
      ['admission/update-question'],
      { queryParams: { questionId: id } });
  }

  deleteQuestion(id: any) {
    this.admService.deleteQuestion(id)
      .subscribe(
        data => {
          this.deleteQuestionAnswers(id);
        },
        error => {
          this.toastrService.warning(this.translate.instant('CAN_NOT_DELETE'));

        }
      );
  }

  getCurrentQuestion(id: any) {
    let getStatus = this.questions.filter((i: any) => i.id == id)[0];
    this.currentQuestionName = this.globals.lang == "en" ? getStatus.questionDescEn : getStatus.questionDescAr;
    this.currentQuestionId = id;
  }

  deleteQuestionAnswers(qId: number) {
    this.admService.deleteAnswersByQuestionId(qId)
      .subscribe(
        data => {
          window.location.reload();
          this.toastrService.success(this.translate.instant('DELETED_SUCCESSFULLY'));
        },
        error => {
          this.toastrService.warning(this.translate.instant('CAN_NOT_DELETE_QUESTIONS_ANSWERS'));

        }
      );
  }


}
